export default __webpack_public_path__ + "static/media/Telephone.cc2ef201.png";